import { RoleGuard } from "app/guards";
import { Navigate, Route, Routes } from "react-router-dom";
import { EmpresaProvider } from "./empresa-context";
import { EmpresaLayout } from "./empresa-layout";
import { ReinscripcionesRoutes } from "./reinscripciones-routes";
import { GeneralRoutes } from "./general-routes";

export function EmpresaRoutes() {
  return (
    <RoleGuard roles={["empresa"]}>
      <EmpresaProvider>
        <Routes>
          <Route path="/" element={<EmpresaLayout />}>
            <Route
              index
              element={<Navigate to="informacion-general" replace />}
            />

            <Route path="informacion-general/*" element={<GeneralRoutes />} />

            {/* <Route
              path="reinscripciones/*"
              element={<ReinscripcionesRoutes />}
            /> */}

            {/* <Route path="afiliacion/*" element={<h1>Afiliación</h1>} /> */}

            <Route path="*" element="Empresa: Page Not Found" />
          </Route>
        </Routes>
      </EmpresaProvider>
    </RoleGuard>
  );
}
